import { IonIcon } from '@ionic/react'
import { HvacOutlined } from '@mui/icons-material'
import ElectricCarOutlinedIcon from '@mui/icons-material/ElectricCarOutlined'
import SolarPowerOutlinedIcon from '@mui/icons-material/SolarPowerOutlined'
import { chevronForward } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { logEvent } from '../../../analytics/utils/firebaseUtils'
import PageWrapper from '../../../wrappers/pageWrapper/PageWrapper'

const AddDevice = () => {
	const { t } = useTranslation('pages_addSmartDevice')

	const history = useHistory()

	const smartDevices = [
		{
			title: t('laite1'),
			description: t('laite1info'),
			icon: (
				<ElectricCarOutlinedIcon className='icon !fill-brand-secondary-100-light dark:!fill-brand-primary-100-dark' />
			),
			onClick: () => {
				logEvent('click-add-ev')
				history.push('/devices/add-device/electric-car')
			},
		},
		{
			title: t('laite2'),
			description: t('laite2info'),
			icon: (
				<SolarPowerOutlinedIcon className='icon !fill-brand-secondary-100-light dark:!fill-brand-primary-100-dark' />
			),
			onClick: () => {
				logEvent('click-add-solar-panel')
				history.push('/devices/add-device/solar-panel')
			},
		},
		{
			title: t('laite3'),
			description: t('laite3info'),
			icon: (
				<HvacOutlined className='icon !fill-brand-secondary-100-light dark:!fill-brand-primary-100-dark' />
			),
			onClick: () => {
				logEvent('click-add-hvac')
				history.push('/devices/add-device/hvac')
			},
		},
	]

	return (
		<PageWrapper page='addDevice' appBarOptions={{ backPath: '/devices' }}>
			{smartDevices.map(e => {
				return (
					<div
						className='hover group smart-device bg-[#f5f5f5] dark:bg-brand-secondary-200-dark border border-brand-secondary-100-light dark:border-brand-secondary-100-dark'
						key={e.title}
						onClick={e.onClick}
					>
						{e.icon}
						<div className='container'>
							<p className='title text-text-dark dark:text-white'>{e.title}</p>
							<p className='description text-text-grey-200 dark:text-text-grey-100'>
								{e.description}
							</p>
						</div>
						<IonIcon
							className='text-[#a3a3a3] dark:text-[#c8c8c8] group-hover:scale-[1.2] group-hover:transition-transform'
							icon={chevronForward}
						/>
					</div>
				)
			})}
		</PageWrapper>
	)
}

export default AddDevice
